/*    
<summary>
   This file is used to provide initial values or state to the User Module observables.
   Developer:Sahil Bharti, Created Date:06-January-2025
</summary>
*/


import { IShiftManagementListVM } from "../../models/response/IShiftManagementResponse";



export const initialState: IShiftManagementListVM = {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    Shifts: []
}